var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checker",on:{"click":function($event){return _vm.toggle()}}},[(_vm.checked)?_c('icon',{staticClass:"small",attrs:{"name":"checked"}}):_vm._e(),(!_vm.checked)?_c('icon',{staticClass:"small",attrs:{"name":"unchecked"}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.caption))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }